document.addEventListener('DOMContentLoaded', function () {
    let jsContentAnimated = Array.prototype.slice.call(document.querySelectorAll('.block_content_animated'));

    jsContentAnimated.forEach(function (self) {
        let left = self.querySelectorAll('.left');
        let right = self.querySelectorAll('.right');

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: self,
                start: 'top 50%',
                end: 'top 20%',
                scrub: true
            }
        })

        tl.to(left, {x: -250})
            .to(right, {x: 250}, 0)
            .eventCallback('onComplete', function () {
                ScrollTrigger.refresh();
            });
    });
});
